//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'product-card-action-view',
  props: {
    linkUrl: String,
  },
  methods: {
    viewProduct(event) {
      console.log('emit view-product', event.target.href);
      this.$parent.$emit('view-product', event);
    },
  },
};
